import React from "react";
import { useLoaderData } from "react-router";
import TwoColumnLayout from "layout/TwoColumnLayout";
import DocumentCopyEditSection from "documentV1/copy/DocumentCopyEditSection";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import { getDocumentRoutes } from "utilities/documentUtils";

export const DocumentV1CopyApp = () => {
  const viewModel = useLoaderData<server.viewmodel.DocumentV1CopyFrontModel>();
  const routes = getDocumentRoutes(viewModel.document.documentType, viewModel.document.documentId);
  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <SectionPanel.Section>
        <DocumentCopyEditSection
          products={viewModel.products}
          document={viewModel.document}
          artistRiders={viewModel.artistRiders}
        />
      </SectionPanel.Section>
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        links={[
          { text: RESX.Buttons.ListView, visible: true, href: viewModel.listUrl },
          { text: RESX.Buttons.DetailView, visible: true, href: routes.detail },

        ]}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>;
};

export default DocumentV1CopyApp;

